<template>
        <div>
        <pdf
        :src="pdfdata"
        v-for="i in numPages"
        :key="i"
        :id="i"
        :page="i"
        :scale.sync="scale"
        style="margin-bottom:20px;"
        >
        <template slot="loading">
            loading content here...
        </template>
        </pdf>
        </div>
</template>
<script>
import pdfvuer from "pdfvuer";
export default {
  props: ["src"],
  components: {
    pdf: pdfvuer,
  },
  data() {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
    };
  },
  computed: {
    formattedZoom() {
      return Number.parseInt(this.scale * 100);
    },
  },
  mounted() {
    this.getPdf();
  },
  watch: {
    show: function(s) {
      if (s) {
        this.getPdf();
      }
    }
  },
  methods: {
    getPdf() {
      var self = this;
      self.pdfdata = pdfvuer.createLoadingTask(this.src);
      self.pdfdata.then((pdf) => {
        self.numPages = pdf.numPages;
      });
    }
  },
};
</script>

<style lang="css" scoped>
#buttons {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
/* Page content */
.content {
  padding: 16px;
}
</style>
